import { API } from '../constants/urls';
import reservationsConsumer from './reservation';

export const reservationsAPI = reservationsConsumer(API, "reservations/client");